import React from 'react';
import Link from 'next/link';
import * as S from './Styles';
import { useRouter } from 'next/router';

const NavigationItem = ({ title, link, icon }) => {
    const { asPath } = useRouter();

    return (
        <Link href={link}>
            <S.NavigationItem active={link === asPath}>
                {icon}

                {title}
            </S.NavigationItem>
        </Link>
    );
};

export { NavigationItem }
